export interface Preset {
	rid: string;
	permissions?: string[];
}

// Maps resource leaftype to preset configuration
export const defaultPermissions: { [key: string]: Preset } = {};

export function addPermissions(leafType: string, config: Preset) {
	defaultPermissions[leafType] = config;
}
